import React, { Component } from "react";
import PropTypes from "prop-types";
import PhotoSwipeCustom from "~/components/PhotoSwipeCustom/PhotoSwipeCustom";
import MobileGallery from "./MobileGallery";
import "react-photoswipe/lib/photoswipe.css";
import "./ImageGallery.scss";
import { buildImgUrl } from "../../utils/misc";

export default class ImageGallery extends Component {
  constructor(props) {
    super(props);
    this._handleGettingData = this._handleGettingData.bind(this);
    this._handleClose = this._handleClose.bind(this);
    this._transformItems = this._transformItems.bind(this);
    this._handleResize = this._handleResize.bind(this);
    this.state = {
      captionTop: null,
    };
  }

  _handleGettingData(gallery, index, item) {
    if (
      item &&
      item.html === undefined &&
      item.onloading === undefined &&
      (item.w < 1 || item.h < 1)
    ) {
      // unknown size
      const img = new Image();
      img.onload = function () {
        // eslint-disable-line
        item.w = this.width; // set image width
        item.h = this.height; // set image height
        gallery.invalidateCurrItems(); // reinit Items
        gallery.updateSize(true); // reinit Items
      };
      img.src = item.src; // let's download image
    }
  }

  _handleClose() {
    this.props.handleGalleryClose();
  }

  _transformItems(media, type) {
    const mediaLength = media.length;
    const images = [];
    let mediaWidth = 1920;
    let mediaHeight = 1080;
    if (type === "service") {
      if (window.innerWidth < 1024) {
        mediaWidth = 993;
        mediaHeight = 559;
      }
    } else {
      if (window.innerWidth < 768) {
        mediaWidth = 750;
        mediaHeight = 500;
      }
    }
    for (let index = 0; index < mediaLength; index++) {
      const image = {
        src: media[index].url.startsWith(this.context.contentBucketBaseUrl)
          ? media[index].url
          : buildImgUrl(media[index].url, mediaHeight, mediaWidth, "https://placehold.it/750x500"),
        w: 0,
        h: 0,
        title: this.props.description,
      };
      images.push(image);
    }
    return images;
  }

  _handleResize() {
    setTimeout(() => {
      const caption = document.getElementsByClassName("pswp__caption");
      const captionContent = document.getElementsByClassName("pswp__caption__center");
      if (
        caption &&
        caption[0] &&
        captionContent &&
        captionContent[0] &&
        caption[0].offsetHeight < captionContent[0].offsetHeight
      ) {
        if (!this.state.showReadMore) {
          this.setState({ showReadMore: true });
        }
      } else {
        if (this.state.showReadMore) {
          this.setState({ showReadMore: false });
        }
      }
    }, 0);
  }

  render() {
    const { _handleGettingData, _handleClose, _transformItems, _handleResize } = this;
    const {
      isOpen,
      imagesList,
      description,
      options,
      type,
      title,
      inventory,
      handleInventory,
      infoOnly,
    } = this.props;
    const { captionTop, showReadMore } = this.state;

    if (window.innerWidth < 1280) {
      return (
        <MobileGallery
          isOpen={isOpen}
          imageList={imagesList}
          title={title}
          description={description}
          inventory={inventory}
          type={type}
          handleClose={_handleClose}
          handleInventory={handleInventory}
          infoOnly={infoOnly}
        />
      );
    }

    return (
      <PhotoSwipeCustom
        isOpen={isOpen}
        items={_transformItems(imagesList, type)}
        title={title}
        description={description}
        options={options}
        onClose={_handleClose}
        gettingData={_handleGettingData}
        resize={_handleResize}
        captionTop={captionTop}
        showReadMore={showReadMore}
        inventory={inventory}
        type={type}
        handleInventory={handleInventory}
        infoOnly={infoOnly}
        handleClose={_handleClose}
      />
    );
  }
}

ImageGallery.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  imagesList: PropTypes.array,
  description: PropTypes.string,
  options: PropTypes.object,
  type: PropTypes.string,
  handleGalleryClose: PropTypes.func.isRequired,
  handleInventory: PropTypes.func,
  title: PropTypes.string,
  inventory: PropTypes.object,
};

ImageGallery.defaultProps = {
  isOpen: false,
  imagesList: [],
  description: "",
  options: {},
  title: "",
  handleGalleryClose() {},
  handleInventory() {},
  inventory: {},
};

ImageGallery.contextTypes = {
  contentBucketBaseUrl: PropTypes.string.isRequired,
};
